import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Quiz from "@/pages/Quiz";
import Result from "@/pages/Result";
import MockPay from "@/pages/MockPay";
import FindResult from "@/pages/FindResult";
import Admin from "@/pages/Admin";
import Tarifs from "@/pages/Tarifs";
import Account from "@/pages/Account";
import Bienvenue from "@/pages/Bienvenue";
import Verifier from "@/pages/Verifier";
import Connexion from "@/pages/Connexion";
import Coach from "@/pages/Coach";
import Credits from "@/pages/Credits";
import Aide from "@/pages/Aide";
import { Cgv, Remboursement, MentionsLegales } from "@/pages/LegalPages";
import { CookieBanner } from "@/components/CookieBanner";

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/result/:id" element={<Result />} />
            <Route path="/mock-pay/:id" element={<MockPay />} />
            <Route path="/retrouver" element={<FindResult />} />
            <Route path="/mes-resultats" element={<FindResult />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/compte" element={<Account />} />
            <Route path="/bienvenue" element={<Bienvenue />} />
            <Route path="/verifier/:hash" element={<Verifier />} />
            <Route path="/connexion" element={<Connexion />} />
            <Route path="/coach" element={<Coach />} />
            <Route path="/credits" element={<Credits />} />
            <Route path="/aide" element={<Aide />} />
            <Route path="/cgv" element={<Cgv />} />
            <Route path="/remboursement" element={<Remboursement />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <CookieBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
